export default __webpack_public_path__ + "static/media/portfolio-49.e37226f9.jpg";